<template>
    <div class="bg-img bg-img-util" :style="{ backgroundImage: 'url(' + imageUrl }">
        <!-- <div class="bg-img bg-img-util"> -->

        <div class="container d-flex align-items-center h-100">
            <div class="row w-100">
                <div class="col-12 col-lg-5">
                    <h1 class="mobile-bg"><strong>{{ titleStrong }}</strong><br v-if="titleStrong">{{ title }}</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['titleStrong', 'title', 'imageUrl']
}
</script>
<style scoped>
.bg-img{
    height: 50vh;
    /* background-image: url('../assets/grants.jpg'); */
}
@media only screen and (max-width: 767px){
    .mobile-bg{ 
        background-color: rgba(266, 266, 266, 0.4); 
        padding: 1rem 2rem;
        

    }
}
</style>

